import MESSAGES from '../messages'

let locale = 'pl'

export const setLocale = (language) => {
  locale = language
}

export const getTranslationFromMessages = (value, language, messages) => {
  if (!value) {
    return ''
  }
  if (!language || !messages || !messages[language]) {
    return value
  }
  let translation = ''
  let context = messages[language]
  const valueArray = value.split('.')
  valueArray.forEach(key => {
    if (typeof context[key] !== 'object') {
      translation = context[key]
    } else {
      context = context[key]
    }
  })
  return translation
}

export const getTranslation = (value) => {
  return getTranslationFromMessages(value, locale, MESSAGES) || value
}

export const getTranslationByLanguage = (value, language) => {
  return getTranslationFromMessages(value, language, MESSAGES) || value
}

export const translateNodesInElement = (element) => {
  if (element.bmPrivacyTranslation) {
    element.textContent = getTranslation(element.bmPrivacyTranslation)
  }
  if (element.children) {
    Array.from(element.children).forEach(node => {
      translateNodesInElement(node)
    })
  }
}
